import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { ElMessageBox } from 'element-plus';
import ElementPlus from 'element-plus';
import * as ElIcons from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import router from './router'; // 引入路由配置
import './styles.css'; // 引入全局样式文件
import './utils/request.js'
import './svgIcon/main.js'
import socketService from './utils/socket'

// 组件注册
import CardShowcaseButton from '@/components/CardShowcaseButton.vue';
import CarouselCard from '@/components/CarouselCard.vue';
import MultiLevelNavMenu from '@/components/MultiLevelNavMenu.vue';
import InputEl from '@/components/InputEl.vue';
import SelectEI from '@/components/SelectEI.vue';
import ModalEI from '@/components/ModalEI.vue';
import SmartImageCard from '@/components/SmartImageCard.vue';
import CardShowVip from '@/components/CardShowVip.vue';
import CardEquitiesShow from '@/components/CardEquitiesShow.vue';
import AppDataDisplay from '@/components/AppDataDisplay.vue';
import TagStandard from '@/components/TagStandard.vue';

// 界面注册
import reportPage from '@/interface/visitProject/reportPage.vue';
import reportEditPage from '@/interface/visitProject/reportEditPage.vue';
import ShuaituMorPPage from '@/interface/stzbxl/ShuaituMorPPage.vue';
import loginPageST from '@/interface/stzbxl/loginPageST.vue';
import GroupPageST from '@/interface/stzbxl/GroupPageST.vue';
import UploadReportPageST from '@/interface/stzbxl/UploadReportPageST.vue';
import SearchPage from '@/interface/stzbxl/SearchPage.vue';
import ForgetPageST from '@/interface/stzbxl/ForgetPageST.vue';
import ShopVIP from '@/interface/stzbxl/ShopVIP.vue';
import IntroducePage from '@/interface/stzbxl/IntroducePage.vue';
import GroupIntroduce from '@/interface/stzbxl/GroupIntroduce.vue';
import UserIntroduce from '@/interface/stzbxl/UserIntroduce.vue';
import ModifyUserIntroduce from '@/interface/stzbxl/ModifyUserIntroduce.vue';
import PersonalPage from '@/interface/stzbxl/PersonalPage.vue';
import ProcessPage from '@/interface/stzbxl/ProcessPage.vue';
import HomePage from '@/interface/stzbxl/HomePage.vue';
import AppCreatOrder from '@/interface/stzbxl/AppCreatOrder.vue';

socketService.connect();

const app = createApp(App);
const pinia = createPinia();

// 全局注册组件
app.component('CardShowcaseButton', CardShowcaseButton);
app.component('CarouselCard', CarouselCard);
app.component('MultiLevelNavMenu', MultiLevelNavMenu);
app.component('InputEl', InputEl);
app.component('SelectEI', SelectEI);
app.component('ModalEI', ModalEI);
app.component('SmartImageCard', SmartImageCard);
app.component('CardShowVip', CardShowVip);
app.component('CardEquitiesShow', CardEquitiesShow);
app.component('AppDataDisplay', AppDataDisplay);
app.component('TagStandard', TagStandard);

// 全局注册界面
app.component('reportPage', reportPage);
app.component('reportEditPage', reportEditPage);
app.component('ShuaituMorPPage', ShuaituMorPPage);
app.component('loginPageST', loginPageST);
app.component('GroupPageST', GroupPageST);
app.component('UploadReportPageST', UploadReportPageST);
app.component('SearchPage', SearchPage);
app.component('ForgetPageST', ForgetPageST);
app.component('ShopVIP', ShopVIP);
app.component('IntroducePage', IntroducePage);
app.component('GroupIntroduce', GroupIntroduce);
app.component('UserIntroduce', UserIntroduce);
app.component('ModifyUserIntroduce', ModifyUserIntroduce);
app.component('PersonalPage', PersonalPage);
app.component('ProcessPage', ProcessPage);
app.component('HomePage', HomePage);
app.component('AppCreatOrder', AppCreatOrder);

// 注册所有图标为全局组件
Object.keys(ElIcons).forEach((key) => {
  app.component(key, ElIcons[key]);
});

// 全局注册消息方法
app.config.globalProperties.$messageX = {
  open1(str) {
    app.config.globalProperties.$message({
      showClose: true,
      message: str
    });
  },
  open2(str) {
    app.config.globalProperties.$message({
      showClose: true,
      message: str,
      type: 'success'
    });
  },
  open3(str) {
    app.config.globalProperties.$message({
      showClose: true,
      message: str,
      type: 'warning'
    });
  },
  open4(str) {
    app.config.globalProperties.$message({
      showClose: true,
      message: str,
      type: 'error'
    });
  },
  /**
   * 
   * @param {*} types 
   * @param {*} messages 
   */
  xiaoxiti(types, messages) {
    if (types == '消息' || types == 'i' || types == 'info' || types == 'x') {
      this.open1(messages);
    } else if (types == '成功' || types == 'c' || types == 'success' || types == 's') {
      this.open2(messages);
    } else if (types == '警告' || types == 'w' || types == 'warning' || types == 'j') {
      this.open3(messages);
    } else if (types == '失败' || types == 'f' || types == 'error' || types == 'e') {
      this.open4(messages);
    } else {
      alert('系统运行出现错误！tip【未知的消息体类型】' + messages);
    }
  },
  generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  /**
   * 提示窗口，弹窗类，仅支持两个按钮事件
   * @param { Object } pops 窗口配置
   * @param { String } pops.magess 提示信息
   * @param { String } pops.magess_title 窗口标题
   * @param { success|error|info|warning } pops.types 提示类别
   * @param { String } pops.confirmButtonText 确定按钮文本
   * @param { String } pops.cancelButtonText 取消按钮文本
   * @param { Object } pops.then 点击确定按钮之后的弹窗配置
   * @param { success|error|info|warning } pops.then.types 点击确定按钮之后的弹窗提示类别
   * @param { String } pops.then.text 点击确定按钮之后的弹窗提示文本
   * @param { Object } pops.catch 点击取消按钮之后的弹窗配置
   * @param { success|error|info|warning } pops.catch.types 点击取消按钮之后的弹窗提示类别
   * @param { String } pops.catch.text 点击取消按钮之后的弹窗提示文本
   * @example {"magess":"确定删除？", "magess_title":"提示", "types":"warning", 
   * "confirmButtonText":"确定", "cancelButtonText":"取消", 
   * "then":{"types":"success", "text":"删除成功！"}, "catch":{"types":"info", "text":"已取消操作！"}}
   * @param { Function } thenCallback 确定时执行方法
   * @param { Function } catchCallback  取消时执行方法
   */
  tipWin(pops, thenCallback, catchCallback) {
    if (typeof (pops) != 'object') {
      this.$messageX.xiaoxiti("f", "系统运行出现错误！tip【传入值pops错误！】");
      return false;
    }
    if (typeof (thenCallback) != 'function' || typeof (catchCallback) != 'function') {
      this.$messageX.xiaoxiti("f", "系统运行出现错误！tip【传入值thenCallback|catchCallback错误！】");
      return false;
    }
    ElMessageBox.confirm(pops.magess ? pops.magess : '确认操作？', pops.magess_title ? pops.magess_title : '提示', {
      confirmButtonText: pops.confirmButtonText ? pops.confirmButtonText : '确定',
      cancelButtonText: pops.cancelButtonText ? pops.cancelButtonText : '取消',
      type: pops.types ? pops.types : 'warning'
    }).then(() => {
      this.xiaoxiti(pops.then ? (pops.then.types ? pops.then.types : 'success') : 'success',
        pops.then ? (pops.then.text ? pops.then.text : '操作成功!') : '操作成功!');
      thenCallback(pops);
    }).catch(() => {
      this.xiaoxiti(
        pops.catch ? (pops.catch.types ? pops.catch.types : 'info') : 'info',
        pops.catch ? (pops.catch.text ? pops.catch.text : '已取消操作！') : '已取消操作！');
      catchCallback(pops);
    });
  },
  /**
 * 校验密码强度
 * 规则：长度8-20位，必须包含大写、小写、数字、特殊字符
 */
  validatePassword(password) {
    // 正则表达式解释：
    // ^                 : 匹配字符串开始
    // (?=.*[a-z])       : 必须包含至少一个小写字母
    // (?=.*[A-Z])       : 必须包含至少一个大写字母
    // (?=.*\d)          : 必须包含至少一个数字
    // (?=.*[@$!%*?&])   : 必须包含至少一个特殊字符 (这里定义了 @$!%*?&)
    // [A-Za-z\d@$!%*?&]{8,20} : 总长度8到20位，且只能包含上述字符
    // $                 : 匹配字符串结束
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;

    return regex.test(password);
  },
  /**
   * 转换时间，将后端拿到的时间转换成直指格式
   * @param { * } gmtString 
   * @param { String } format 默认传入格式为【YYYY-MM-DD】
   * | 代码 | 含义 | 示例 (基于你的当前时间) |
   * | :--- | :--- | :--- |
   * | %Y | 四位数年份 | `2026` |
   * | %y | 两位数年份 | `26` |
   * | %m | 月份 (01-12) | `05` |
   * | %B | 月份全名 | `May` |
   * | %b | 月份简称 | `May` |
   * | %d | 日期 (01-31) | `10` |
   * | %A | 星期全名 | `Sunday` |
   * | %a | 星期简称 | `Sun` |
   * | %H | 小时 (24小时制, 00-23) | `14` |
   * | %I | 小时 (12小时制, 01-12) | `02` |
   * | %M | 分钟 (00-59) | `30` |
   * | %S | 秒数 (00-59) | `45` |
   * | %s | 豪秒 (0-999) | `666` |
   * | %p | 上午下午 | `'PM' : 'AM'` |
   * @returns 返回指定格式的日期
   */
  formatGmtToLocal(gmtString, formatString) {
    // 1. 创建 Date 对象
    const date = new Date(gmtString);

    // 2. 检查是否有效
    if (isNaN(date)) return '无效时间';

    // 3. 准备数据映射表
    // 这里处理了所有你需要的格式代码
    const map = {
      // --- 年份 ---
      '%Y': date.getFullYear(), // 2026
      '%y': String(date.getFullYear()).slice(-2), // 26

      // --- 月份 ---
      '%m': String(date.getMonth() + 1).padStart(2, '0'), // 05
      '%B': date.toLocaleString('zh-CN', { month: 'long' }), // 5月 (或 May)
      '%b': date.toLocaleString('en-US', { month: 'short' }), // May

      // --- 日期 ---
      '%d': String(date.getDate()).padStart(2, '0'), // 10

      // --- 星期 ---
      // 使用 toLocaleString 获取本地化的星期名称
      '%A': date.toLocaleString('zh-CN', { weekday: 'long' }), // 星期日
      '%a': date.toLocaleString('zh-CN', { weekday: 'short' }), // 周日

      // --- 小时 ---
      '%H': String(date.getHours()).padStart(2, '0'), // 16 (24小时制)
      '%I': String(date.getHours() % 12 || 12).padStart(2, '0'), // 04 (12小时制)

      // --- 分钟/秒/毫秒 ---
      '%M': String(date.getMinutes()).padStart(2, '0'), // 31
      '%S': String(date.getSeconds()).padStart(2, '0'), // 25
      '%s': date.getMilliseconds(), // 毫秒 (通常不补零)

      // --- 上午/下午 ---
      '%p': date.getHours() >= 12 ? 'PM' : 'AM',
    };

    // 4. 执行替换
    // 使用正则表达式全局匹配 (g)
    return formatString.replace(/%[YymBbdaHIpMSs]/g, (match) => {
      return map[match] !== undefined ? map[match] : match;
    });
  },
  /**
   * 拿到一个字符串，将其按照指定的分隔符进行拆分，并且按照指定模式进行处理，并返回一个数组
   * @param {String} value 
   * @param {String} str 
   * @param {String} mode 接受值为【Tag】
   */
  organizeLabelData(value, str, mode = 'default') {
    let result = [];
    if(mode == 'Tag'){
      value = value.split(str);
      for(let item of value){
        item ? result.push({ 'name': item }) : item;
      }
    }
    return result;
  },
  /**
   * 通过传入的字符串，返回一个指定的分隔符
   * @param {String} value 
   */
  retrieveIdentifier(value){
    let result = '';
    if (value === 'Tag') {
      result = '*';
    }
    return result;
  }
};
app.config.globalProperties.$socket = socketService;

app.use(pinia);
app.use(ElementPlus);
app.use(router); // 使用路由
app.mount('#app');
